export const convertStringToUrlFormat = (string, replacementChar = '-') => {
  if (!string) {
    return null;
  }
  // removes everything expect letters and spaces
  // converts the spaces into dashes
  // then lowercases everything
  return string
    .replace(/[^\w\s]/gi, '')
    .replace(/\s+/g, replacementChar)
    .toLowerCase();
};

export const convertUrlFormatToString = string => {
  if (!string) {
    return null;
  }
  // replaces all dashes with spaces
  // capitalizes first word
  return string.charAt(0).toUpperCase() + string.slice(1).replace(/-/g, ' ');
};
